export enum ActionTypes {
  SET_COLOR = 'slash/SET_COLOR',
}
